import axios from 'axios';
import { createNamespacedHelpers } from "vuex";

const state = {
  isLoading: false,
  all: [],
}

const getters = {
  options(state) {
    return state.all.map(pt => ({ value: pt.type, text: pt.name }));
  }
}

const mutations = {
  startLoad() {
    this.isLoading = true;
  },
  loadAllSuccess(state, payrollTypes) {
    state.isLoading = false;
    state.all = payrollTypes;
  }
}

const actions = {
  async loadAll({ commit }) {
    commit('startLoad');

    let response = await axios.get('/api/payroll-types');

    commit('loadAllSuccess', response.data);
  }
}

export const {
  mapState: mapPayrollTypesState,
  mapGetters: mapPayrollTypesGetters,
  mapMutations: mapPayrollTypesMutations,
  mapActions: mapPayrollTypesActions
} = createNamespacedHelpers('payrollTypes');

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
